export const isProduction = process.env.NODE_ENV === 'production';

export const basename = process.env.BASENAME;

export const liffId = process.env.LIFF_ID;

export const orderConsultURL = process.env.ORDER_CONSULT_URL;

export const appRoutePrefix = {
  tutorial: process.env.APP_ROUTE_PREFIX_TUTORIAL,
  payShop: process.env.APP_ROUTE_PREFIX_PAYSHOP,
};

export const apiProxy = {
  prefix: process.env.API_PROXY_PREFIX,
  payshop: {
    prefix: process.env.API_PROXY_PREFIX_PAYSHOP,
    version: process.env.PAYSHOP_API_VERSION,
  },
  meta: {
    prefix: process.env.API_PROXY_PREFIX_META,
    version: process.env.META_API_VERSION,
  },
  tutorial: {
    prefix: process.env.API_PROXY_PREFIX_TUTORIAL,
    version: process.env.TUTORIAL_API_VERSION,
  },
  liffUser: {
    prefix: process.env.API_PROXY_PREFIX_LIFF_USER,
    version: process.env.USER_INTERNAL_API_VERSION,
  },
  ad: {
    prefix: process.env.API_PROXY_PREFIX_AD,
    version: process.env.AD_API_VERSION,
  },
};

export const externalUrl = {
  faq: {
    ios: process.env.IOS_FAQ_URL,
    aos: process.env.AOS_FAQ_URL,
  },
  tos: process.env.TOS_URL,
};

export const systemConfig = {
  bannerNumber: Number(process.env.BANNER_NUMBER),
  bannerAutoPlayInterval: Number(process.env.BANNER_AUTO_PLAY_INTERVAL),
};

export const sellerKey = process.env.SELLER_KEY;
export const serviceId = process.env.SERVICE_ID;

export const utsConfig = {
  endpoint: process.env.UTS_API_SERVER_URL,
  utsId: process.env.UTS_UPAY_UTS_ID,
  appName: process.env.UTS_UPAY_APP_NAME,
  appEnv: process.env.UTS_APP_ENV,
};

export const appScheme = {
  upay: process.env.UPAY_APP_SCHEME,
};
